<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <section>
    <div class="content-wrapper pos-rel-md">
      <h1 class="title">{{ pageData.title || 'My Insurance' }}</h1>
      <div class="separator"></div>
      <div class="heading-container my-insurance-container-box">
        <h2 class="my-insurance-heading">
          {{ pageData.title || 'My Insurance' }}
          <span
            >(<span>{{ auth.currentUser?.coverCount ?? 0 }}</span
            >)</span
          >
        </h2>
        <h5 class="bold">
          {{
            pageData.intro_bold ||
              'View details of the Howden for Students contents cover applicable to the university accommodation or any policies bought through Howden for Students with easy links to your documents.'
          }}
        </h5>
        <h5>
          {{ pageData.intro }}
        </h5>
      </div>
      <div class="flex-container cover-container">
        <div
          class="contents-cover my-insurance-container-box"
          *ngIf="auth.currentUser?.accommodation?.covered"
        >
          <h2>Howden contents cover</h2>
          <h5 class="tertiary">
            <span *ngIf="auth.currentUser?.university"
              >{{ auth.currentUser?.university?.name }},
            </span>
            <span *ngIf="auth.currentUser?.accommodation">{{
              auth.currentUser?.accommodation?.name
            }}</span>
            <br />
          </h5>
          <a routerLink="/app/my-insurance/update">Update</a>
          <div class="claim">
            <h3>Need to make a claim?</h3>
            <div class="claim-contacts">
              <h4 *ngIf="pageData.claims_link">
                <a [href]="pageData.claims_link" [target]="'_blank'">{{
                  pageData.claims_link_text
                }}</a>
                or Call&nbsp;
                <h4
                  *ngIf="pageData.uk_claims_line"
                  [ngClass]="{
                    'inline-display': !updatedAccommodation().show_ireland_line
                  }"
                >
                  <span
                    class="country"
                    *ngIf="updatedAccommodation().show_ireland_line"
                    >UK:
                  </span>
                  <a href="{{ 'tel:' + pageData.uk_claims_line }}">{{
                    pageData.uk_claims_line
                  }}</a>
                </h4>
                <h4
                  *ngIf="
                    updatedAccommodation().show_ireland_line &&
                    pageData.ireland_claims_line
                  "
                >
                  <span class="country">Republic of Ireland: </span>
                  <a href="{{ 'tel:' + pageData.ireland_claims_line }}">{{
                    pageData.ireland_claims_line
                  }}</a>
                </h4>
              </h4>
              <h4
                *ngIf="
                  !pageData.uk_claims_line &&
                  !pageData.claims_link &&
                  !isLoading()
                "
              >
                There was a problem retrieving claim contact information. Please
                <a routerLink="/contact-us">Contact Us</a> if you need to make a
                claim.
              </h4>
            </div>
          </div>
          <div class="policy-buttons">
            <div class="spinner center" *ngIf="isLoading()"></div>
            <a
              *ngIf="showSitesCoveredButton()"
              [href]="updatedAccommodation().sites_covered_url"
              target="_blank"
              class="button sites-covered"
              >Check if your site is covered</a
            >
            <a
              *ngIf="certificateUrl()"
              [href]="certificateUrl()"
              target="_blank"
              class="button policy-cert"
              >Policy certificate</a
            >
            <a
              *ngIf="keyWordingUrl()"
              [href]="keyWordingUrl()"
              target="_blank"
              class="button key-facts"
              >Key facts</a
            >
            <a
              *ngIf="policyUrl()"
              [href]="policyUrl()"
              target="_blank"
              class="button policy-wording"
              >Policy wording</a
            >
          </div>

          <div
            *ngIf="showPolicyChange()"
            class="policy-year-change"
            [innerHTML]="
              policyYearChangeMessage().replace('{date}', policyChangeYear())
            "
          ></div>
        </div>
        <div
          class="contents-cover no-cover my-insurance-container-box"
          *ngIf="showNoContentsCards()"
        >
          <h2>{{ pageData.no_cover_heading }}</h2>
          <h5 class="tertiary">
            <span *ngIf="auth.currentUser?.university"
              >{{ auth.currentUser?.university?.name }},
            </span>
            <span *ngIf="auth.currentUser?.accommodation">{{
              auth.currentUser?.accommodation?.name
            }}</span>
            <br />
          </h5>
          <div class="no-cover-text">
            <app-render-markdown
              [content]="pageData.no_cover_content"
            ></app-render-markdown>
          </div>
          <a class="button primary-button" routerLink="/app/my-insurance/update"
            >Update details</a
          >
        </div>
        <div
          class="contents-cover no-cover my-insurance-container-box"
          *ngIf="auth.currentUser?.coveredError"
        >
          <h2>Cover Retrieval Error</h2>
          <h4>
            There was an error retrieving details of your accommodation cover.
          </h4>
          <h4>Please log out and back in again to refresh your session.</h4>
          <h4>
            If the problem persists, please
            <a routerLink="/contact-us/form">Contact Us</a>.
          </h4>
          <a class="button button-primary" (click)="auth.logout()">Logout</a>
        </div>
        <div
          class="desktop-image"
          [ngStyle]="{
            'background-image':
              'url(' + pageData?.contents_cover_img?.data?.attributes?.url + ')'
          }"
        ></div>
      </div>
      <div
        class="international my-insurance-container-box"
        *ngIf="auth.currentUser?.university?.is_pathway_provider"
      >
        <div class="text">
          <h2>{{ auth.currentUser?.university?.pathway_provider_title }}</h2>
          <h5>{{ internationalStudentData().dashboard_banner_content }}</h5>
        </div>
        <a
          class="button primary-button"
          routerLink="/app/international-student"
          >{{ internationalStudentData().dashboard_banner_cta }}</a
        >
      </div>
      <div class="policies">
        <!-- User Insurance Products -->
        <ng-container *ngIf="auth.currentUser?.insuranceProducts?.length">
          <div
            class="policy my-insurance-container-box"
            *ngFor="
              let userInsuranceProduct of auth.currentUser?.insuranceProducts
            "
          >
            <h2>{{ userInsuranceProduct.product.productName }}</h2>
            <div class="flex-container policy-top">
              <div class="product-text">
                <h4 class="product-premium">
                  Premium: {{ userInsuranceProduct.amount | currency: 'GBP' }}
                </h4>
              </div>
              <div class="product-dates">
                <h5>
                  Started:
                  {{ userInsuranceProduct.startDate | date: 'dd/MM/yyyy' }}
                </h5>
                <h5>
                  Expires:
                  {{ userInsuranceProduct.endDate | date: 'dd/MM/yyyy' }}
                </h5>
              </div>
            </div>
            <div class="separator"></div>
            <div class="flex-container policy-bottom">
              <h5>{{ userInsuranceProduct.product.description }}</h5>
              <a
                class="button primary-button"
                target="_blank"
                [href]="userInsuranceProduct.product.linkURL"
                >Go to {{ userInsuranceProduct.product.provider.name }}</a
              >
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <img
      class="mobile-bg-img"
      [src]="pageData?.contents_cover_img_mobile?.data?.attributes?.url"
    />
  </section>
</div>
